import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // Named/Default import for autoTable function

/**
 * Date of Birth se current age calculate karne ke liye helper function
 */
const calculateAge = (dobString) => {
  if (!dobString) return "N/A";
  const birthDate = new Date(dobString);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age >= 0 ? `${age} Yrs` : "N/A";
};

/**
 * PDF Export Utility Function
 */
export const exportToPdf = (customerList = [], companyName = "COMPANY NAME") => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  // 1. Title / Header Section
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(companyName.toUpperCase(), doc.internal.pageSize.getWidth() / 2, 15, {
    align: "center",
  });

  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");
  doc.text("Candidate / Student List", doc.internal.pageSize.getWidth() / 2, 22, {
    align: "center",
  });

  // 2. Table Column Headers
  const tableColumn = [
    "S.No",
    "Reg. No",
    "Full Name",
    "Father's Name",
    "DOB",
    "Age",
    "Gender",
    "Mobile No",
    "Email",
    "Address",
  ];

  // 3. Data Formatting with Age Calculation & Serial Number
  const tableRows = customerList.map((student, index) => [
    index + 1,
    student.registration_no || "N/A",
    student.full_name || `${student.first_name || ""} ${student.last_name || ""}`.trim() || "N/A",
    student.father_name || "N/A",
    student.date_of_birth || "N/A",
    calculateAge(student.date_of_birth),
    student.gender || "N/A",
    student.mobile_no || "N/A",
    student.email || "N/A",
    student.address || "N/A",
  ]);

  // 4. Call autoTable directly passing 'doc' instance
  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 28,
    theme: "grid",
    headStyles: {
      fillColor: [25, 118, 210],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      halign: "center",
    },
    styles: {
      fontSize: 8,
      cellPadding: 2,
      valign: "middle",
    },
    columnStyles: {
      0: { halign: "center", cellWidth: 10 },
      1: { cellWidth: 28 },
      2: { cellWidth: 30 },
      3: { cellWidth: 30 },
      4: { halign: "center", cellWidth: 22 },
      5: { halign: "center", cellWidth: 15 },
      6: { halign: "center", cellWidth: 18 },
      7: { cellWidth: 25 },
      8: { cellWidth: 35 },
      9: { cellWidth: "auto" },
    },
    didDrawPage: (data) => {
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFontSize(8);
      doc.text(
        `Page ${data.pageNumber} of ${pageCount}`,
        doc.internal.pageSize.getWidth() - 20,
        doc.internal.pageSize.getHeight() - 10
      );
    },
  });

  // 5. Save File
  const fileName = `${companyName.replace(/\s+/g, "_")}_Candidates_${new Date().toISOString().slice(0, 10)}.pdf`;
  doc.save(fileName);
};